module.exports = __webpack_public_path__ + "static/media/lock-icon.1e17fb45.svg";